import { useState, useEffect } from 'react';

function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    if (window.matchMedia('(display-mode: standalone)').matches) return;
    if (localStorage.getItem('ra-install-dismissed')) return;

    const ua = navigator.userAgent;
    const ios = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (ios && !navigator.standalone) {
      setIsIOS(true);
      setShowBanner(true);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      setDeferredPrompt(null);
    }
    setShowBanner(false);
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('ra-install-dismissed', 'true');
  };

  if (!showBanner) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      padding: '0 12px 12px',
      pointerEvents: 'none',
    }}>
      <div style={{
        maxWidth: 480,
        margin: '0 auto',
        background: 'linear-gradient(135deg, rgba(10,15,28,0.97), rgba(17,24,39,0.97))',
        border: '1px solid rgba(0,255,157,0.25)',
        borderRadius: 16,
        padding: '16px 20px',
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        boxShadow: '0 -4px 30px rgba(0,0,0,0.5), 0 0 40px rgba(0,255,157,0.08)',
        backdropFilter: 'blur(20px)',
        pointerEvents: 'auto',
      }}>
        <img src="/logo.png" alt="Retail Alpha" style={{
          width: 44,
          height: 44,
          borderRadius: 10,
          objectFit: 'contain',
          flexShrink: 0,
        }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ color: '#f1f5f9', fontWeight: 700, fontSize: 14, marginBottom: 2 }}>
            Install Retail Alpha
          </div>
          {isIOS ? (
            <div style={{ color: '#94a3b8', fontSize: 12, lineHeight: 1.4 }}>
              Tap <span style={{ color: '#00ff9d' }}>Share</span> then <span style={{ color: '#00ff9d' }}>"Add to Home Screen"</span>
            </div>
          ) : (
            <div style={{ color: '#94a3b8', fontSize: 12, lineHeight: 1.4 }}>
              Add to your home screen for the best experience
            </div>
          )}
        </div>
        <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
          {!isIOS && (
            <button onClick={handleInstall} style={{
              background: '#00ff9d',
              color: '#0a0f1c',
              border: 'none',
              borderRadius: 8,
              padding: '8px 16px',
              fontWeight: 700,
              fontSize: 13,
              cursor: 'pointer',
              fontFamily: 'Inter, sans-serif',
            }}>
              Install
            </button>
          )}
          <button onClick={handleDismiss} style={{
            background: 'rgba(255,255,255,0.06)',
            color: '#94a3b8',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: 8,
            padding: '8px 12px',
            fontSize: 13,
            cursor: 'pointer',
            fontFamily: 'Inter, sans-serif',
          }}>
            {isIOS ? 'Got it' : 'Later'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default InstallPrompt;
